var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.start)?_c('message-push-native',{attrs:{"URL":_vm.url,"token":_vm.token,"username":_vm.username,"componentSet":_vm.componentSet},on:{"message-get":_vm.onMessageGet}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }